import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import LiveTracking from "views/admin/liveTracking";
import RouteTracking from "views/admin/routeTracking";
import Profile from "views/admin/profile";
import Reports from "views/admin/reports";
import Geofence from "views/admin/geofence";
import Notifications from "views/admin/notifications";
import Configure from "views/admin/configure";
import UserDeviceManagement from "views/admin/userDeviceManagement";
import ZoneBranches from "views/admin/zoneBranches";
// Icon Imports
import {
  MdHome,
  MdBarChart,
  MdNotificationsActive,
} from "react-icons/md";
import { TbLiveView  } from "react-icons/tb";
import { TbFence  } from "react-icons/tb";
import { FaRoute } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { MdSettings, MdAccountTree, MdStore } from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Live Tracking",
    layout: "/admin",
    path: "Live-Tracking",
    icon: <TbLiveView  className="h-6 w-6" />,
    component: <LiveTracking />,
    secondary: true,
    allow: (access) => !access || access.canLiveTrack,
  },
  {
    name: "Reports",
    layout: "/admin",
    icon: <MdBarChart className="h-6 w-6" />,
    path: "Reports",
    component: <Reports />,
    allow: (access) => !access || access.canReports,
  },
  {
    name: "Route Tracking",
    layout: "/admin",
    path: "Route-Tracking",
    icon: <FaRoute className="h-6 w-6" />,
    component: <RouteTracking />,
    allow: (access) => !access || access.canLiveTrack,
  },
  {
    name: "Geofence",
    layout: "/admin",
    path: "Geofence",
    icon: <TbFence className="h-6 w-6" />,
    component: <Geofence />,
    allow: (access) => !access || access.canViewGeofence,
  },
  {
    name: "Notifications & Alerts",
    layout: "/admin",
    path: "Notifications",
    icon: <MdNotificationsActive className="h-6 w-6" />,
    component: <Notifications />,
  },
  {
    name: "Configure",
    layout: "/admin",
    path: "Configure",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Configure />,
    allow: (access) => !access || access.canConfigure,
  },
  {
    name: "User & Device control",
    layout: "/admin",
    path: "User-Device-Management",
    icon: <MdAccountTree className="h-6 w-6" />,
    component: <UserDeviceManagement />,
    allow: (access) => !!access?.canManageUsers,
  },
  {
    name: "Zone Branches",
    layout: "/admin",
    path: "Zone-Branches",
    icon: <MdStore className="h-6 w-6" />,
    component: <ZoneBranches />,
    allow: (access) => !!access?.canZoneBranches,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "Profile",
    icon: <CgProfile className="h-6 w-6" />,
    component: <Profile />,
  },
];
export default routes;
